import { useDealItemPicker } from './DealItemPicker';
import { Button } from 'components/Button';
import { Money } from 'components/Money';
import { Table } from 'components/table/Table';
import { TableActions, isTableSearchValueEmpty } from 'components/table/TableActions';
import { Text } from 'components/Text';
import { Fragment, classNames, useState } from 'libs/react';
import { React } from 'libs/react';
import { SaleItemIcon } from 'modules/catalog/saleItem/components/SaleItemIcon';
import { calculatePriceCurrency } from 'helpers/Pricing';
import { useTranslation } from 'components/translation/TranslationProvider';
import { getFieldValue, getFieldValueLabel } from 'helpers/Field';
import { SaleItemsListQuery } from 'graphql/Deal/queries/dealItemPicker/SaleItemListQuery';
import { Spinner } from 'components/Spinner';
import { Icon } from 'components/Icon';
import { FormInput } from 'components/form/FormInput';
import './DealItemPickerBrowseTable.scss';
/**
 * @component DealItemPickerBrowseTable
 * @since 1.0.0
 */
export function DealItemPickerBrowseTable(props) {
    let { values, fetching, itemsDisplay, promotedFields, filterBy } = props;
    const { customLabels, language } = useTranslation();
    const { addItem, currencies, onQuantityChange, hideSku } = useDealItemPicker();
    const [searching, setSearching] = useState(false);
    const [cardDisplay, setCardDisplay] = useState(
    //itemsDisplay !== 'VARIANT_GROUPED'
    false);
    const [isCardDisplay, setIsCardDisplay] = useState(false);
    const [loadingRow, setLoadingRow] = useState('');
    const defaultCurrency = currencies === null || currencies === void 0 ? void 0 : currencies.find((currency) => currency.primary);
    let primaryColumn = 'c3';
    /**
     * @function onSearch
     * @since 1.0.0
     */
    const onSearch = (value) => {
        setSearching(isTableSearchValueEmpty(value) == false);
        if (props.onSearch) {
            props.onSearch(value);
        }
    };
    const formattedValues = [];
    const columns = [];
    if (itemsDisplay === 'ITEM_WITH_VARIANT') {
        values === null || values === void 0 ? void 0 : values.forEach((saleItem) => {
            var _a;
            if ((_a = saleItem.variants) === null || _a === void 0 ? void 0 : _a.length) {
                saleItem.variants.forEach((variant) => {
                    if (variant.values.length) {
                        let variantValue = '';
                        variant.values.forEach((value) => {
                            variantValue += `${getFieldValueLabel(value.value, value.field, language)} `;
                        });
                        formattedValues.push({
                            sku: saleItem.sku,
                            title: saleItem.title,
                            price: variant.price,
                            id: saleItem.id,
                            variantId: variant.id,
                            variant: variant,
                            variantValue: variantValue,
                            item: saleItem,
                            description: saleItem.infos,
                            fieldValues: variant.values
                                ? saleItem.fieldValues.concat(variant.fieldValues)
                                : saleItem.fieldValues
                        });
                    }
                    else {
                        formattedValues.push({
                            sku: saleItem.sku,
                            title: saleItem.title,
                            price: saleItem.price,
                            id: saleItem.id,
                            item: saleItem,
                            description: saleItem.infos,
                            fieldValues: saleItem.fieldValues
                        });
                    }
                });
            }
            else {
                formattedValues.push({
                    sku: saleItem.sku,
                    title: saleItem.title,
                    price: saleItem.price,
                    id: saleItem.id,
                    item: saleItem,
                    description: saleItem.infos,
                    fieldValues: saleItem.fieldValues
                });
            }
        });
        columns.push({
            column: 'image',
            type: 'image',
            header: '',
            footer: '',
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(SaleItemIcon, { item: value.item })));
            }
        });
        columns.push({
            column: 'title',
            header: t('Name'),
            footer: t('Name'),
            hideLabelInCard: true,
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { className: "table-row-title", value: value.variantValue
                            ? `${value === null || value === void 0 ? void 0 : value.title} - ${value.variantValue}`
                            : value.title })));
            }
        });
        if (promotedFields === null || promotedFields === void 0 ? void 0 : promotedFields.length) {
            promotedFields.forEach((field) => {
                columns.push({
                    column: field.name,
                    header: field.title,
                    infos: field.infos,
                    footer: field.title,
                    render: (value) => {
                        var _a;
                        let fieldVal = '';
                        const fieldValue = (_a = value.fieldValues) === null || _a === void 0 ? void 0 : _a.find((v) => v.field.id === field.id);
                        if (fieldValue) {
                            isNaN(JSON.parse(fieldValue.value).value)
                                ? (fieldVal = getFieldValue(JSON.parse(fieldValue.value), language))
                                : (fieldVal = JSON.parse(fieldValue.value).value.replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
                        }
                        return (React.createElement(Fragment, null,
                            React.createElement(Text, { className: "table-row-title", value: fieldVal })));
                    }
                });
            });
        }
        else {
            columns.push({
                column: 'infos',
                header: t('Description'),
                footer: t('Description'),
                hideLabelInCard: true,
                render: (value) => {
                    return (React.createElement(Fragment, null,
                        React.createElement(Text, { className: "table-row-title", value: value.description.length > 50
                                ? value.description.slice(0, 50).concat('...')
                                : value.description })));
                }
            });
        }
        columns.push({
            column: 'quantity',
            header: t('Quantity'),
            footer: t('Quantity'),
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement("div", { className: "table-row-status", onClick: (e) => {
                            e.stopPropagation();
                        } },
                        React.createElement(FormInput, { type: "number", className: "table-row-title", value: "1", min: "1", onChange: (value) => {
                                onQuantityChange(Number(value));
                            }, size: "small" }))));
            }
        });
        columns.push({
            column: 'price',
            header: t('Price'),
            footer: t('Price'),
            hideLabelInCard: true,
            render: (value) => {
                return (React.createElement("div", { className: "table-row-value table-row-value--price money-variant" },
                    React.createElement(Money, { value: calculatePriceCurrency(value.price, defaultCurrency) })));
            }
        });
        columns.push({
            column: '',
            type: 'actions',
            header: '',
            footer: '',
            render: (value) => {
                return (React.createElement("div", { onClick: (e) => {
                        e.stopPropagation();
                    } }, loadingRow !== value.variantId ? (React.createElement(Button, { style: "circle", picto: "plus", onPress: () => {
                        setLoadingRow(value.variantId);
                        addItem(value.item, value.variant);
                    } })) : (React.createElement(Spinner, { className: "deal-item-picker-browse-table-spinner" }))));
            }
        });
    }
    else if (itemsDisplay === 'VARIANT_GROUPED') {
        values === null || values === void 0 ? void 0 : values.forEach((saleItem) => {
            // sort variant by sku
            const variants = [
                ...saleItem.variants.filter((variant) => variant.active === true)
            ];
            variants.sort((a, b) => {
                if (a.sku && b.sku) {
                    return a.sku.localeCompare(b.sku);
                }
                return 0;
            });
            formattedValues.push({
                sku: saleItem.sku,
                title: saleItem.title,
                summary: saleItem.summary,
                infos: saleItem.infos,
                price: saleItem.price,
                id: saleItem.id,
                item: saleItem,
                fieldValues: saleItem.fieldValues,
                variants: variants,
                configuration: saleItem.configuration
            });
        });
        columns.push({
            column: 'image',
            type: 'image',
            header: '',
            footer: '',
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(SaleItemIcon, { item: value.item })));
            }
        });
        columns.push({
            column: 'title',
            header: '',
            footer: '',
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { className: "table-row-title", value: value.title })));
            }
        });
        columns.push({
            column: 'variants',
            header: '',
            footer: '',
            render: (value) => {
                var _a, _b, _c;
                return (React.createElement(Fragment, null,
                    React.createElement("div", { className: "table-row-value table-row-value--variant" },
                        ((_a = value.variants) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                            value.variants[0].values.map((value) => {
                                return (React.createElement("div", { className: "table-row-value--variant-value  table-row-value--variant-value-header", key: value.id }, value.field.title));
                            }),
                        promotedFields &&
                            (promotedFields === null || promotedFields === void 0 ? void 0 : promotedFields.length) > 0 &&
                            promotedFields
                                .filter((field) => {
                                var _a;
                                return (_a = value.variants) === null || _a === void 0 ? void 0 : _a.find((variant) => {
                                    var _a;
                                    return (_a = variant.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => {
                                        return field.id === fieldValue.field.id;
                                    });
                                });
                            })
                                .map((field) => {
                                return (React.createElement("div", { className: "table-row-value--variant-value  table-row-value--variant-value-header", key: field.id },
                                    field.title,
                                    field.infos && (React.createElement("div", { className: "table-label-tooltip" },
                                        React.createElement(Icon, { className: "table-label-tooltip-picto", value: "circle-info" }),
                                        React.createElement(Text, { className: "table-label-tooltip-value", value: field.infos })))));
                            }),
                        React.createElement("div", { className: "table-row-value--variant-quantity table-row-value--variant-value-header" }, t('Quantity')),
                        React.createElement("div", { className: "table-row-value--variant-price table-row-value--variant-value-header" },
                            t('Price'),
                            " (", defaultCurrency === null || defaultCurrency === void 0 ? void 0 :
                            defaultCurrency.code,
                            ")"),
                        React.createElement("div", { className: "table-row-value--variant-add" })),
                    (((_b = value.variants) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                        ((_c = value.variants) === null || _c === void 0 ? void 0 : _c.map((variant) => {
                            return (React.createElement("div", { className: "table-row-value table-row-value--variant", key: variant.id, onClick: (e) => {
                                    e.stopPropagation();
                                    setLoadingRow(variant.id);
                                    addItem(value.item, variant);
                                } },
                                variant.values.map((value) => {
                                    return (React.createElement("div", { className: "table-row-value--variant-value", key: value.id }, getFieldValueLabel(value.value, value.field, language)));
                                }),
                                promotedFields &&
                                    (promotedFields === null || promotedFields === void 0 ? void 0 : promotedFields.length) > 0 &&
                                    variant.fieldValues &&
                                    promotedFields.map((field) => {
                                        var _a, _b, _c;
                                        return (React.createElement("div", { className: "table-row-value--variant-value", key: field.id },
                                            React.createElement("div", { className: "table-row-value--variant-value-content" }, ((_a = variant.fieldValues) === null || _a === void 0 ? void 0 : _a.find((fieldValue) => {
                                                return field.id === fieldValue.field.id;
                                            }))
                                                ? getFieldValueLabel(JSON.parse((_c = (_b = variant.fieldValues) === null || _b === void 0 ? void 0 : _b.find((fieldValue) => {
                                                    return (field.id === fieldValue.field.id);
                                                })) === null || _c === void 0 ? void 0 : _c.value).value, field, language)
                                                : '')));
                                    }),
                                React.createElement("div", { className: "table-row-value--variant-quantity" },
                                    React.createElement("div", { className: "table-row-value--variant-value-content", onClick: (e) => {
                                            e.stopPropagation();
                                        } },
                                        React.createElement(FormInput, { type: "number", className: "table-row-title", value: "1", min: "1", onChange: (value) => {
                                                onQuantityChange(Number(value));
                                            }, size: "small" }))),
                                React.createElement("div", { className: "table-row-value--variant-price" },
                                    React.createElement(Money, { value: calculatePriceCurrency(variant.price, defaultCurrency) })),
                                React.createElement("div", { className: "table-row-value--variant-add", onClick: (e) => {
                                        e.stopPropagation();
                                    } }, loadingRow !== variant.id ? (React.createElement(Button, { style: "circle", picto: "plus", onPress: () => {
                                        setLoadingRow(variant.id);
                                        addItem(value.item, variant);
                                    } })) : (React.createElement(Spinner, { className: "deal-item-picker-browse-table-spinner" })))));
                        }))) || (React.createElement("div", { className: "table-row-value table-row-value--variant table-row-value--no-variant" },
                        React.createElement("div", { className: "table-row-value--variant-values" }),
                        React.createElement("div", { className: "table-row-value--variant-quantity" },
                            React.createElement("div", { className: "table-row-value--variant-value-content", onClick: (e) => {
                                    e.stopPropagation();
                                } },
                                React.createElement(FormInput, { type: "number", className: "table-row-title", value: "1", min: "1", onChange: (value) => {
                                        onQuantityChange(Number(value));
                                    }, size: "small" }))),
                        React.createElement("div", { className: "table-row-value--variant-price" },
                            React.createElement(Money, { value: calculatePriceCurrency(value.price, defaultCurrency) })),
                        React.createElement("div", { onClick: (e) => {
                                e.stopPropagation();
                            } }, loadingRow !== value.id ? (React.createElement(Button, { style: "circle", picto: "plus", onPress: () => {
                                setLoadingRow(value.id);
                                addItem(value.item);
                            } })) : (React.createElement(Spinner, { className: "deal-item-picker-browse-table-spinner" })))))));
            }
        });
        primaryColumn = 'c2';
    }
    else {
        values === null || values === void 0 ? void 0 : values.forEach((saleItem) => {
            // sort variants by price
            const variants = [...saleItem.variants];
            variants.sort((a, b) => { var _a, _b; return ((_a = a.price) !== null && _a !== void 0 ? _a : 0) - ((_b = b.price) !== null && _b !== void 0 ? _b : 0); });
            formattedValues.push({
                sku: saleItem.sku,
                title: saleItem.title,
                summary: saleItem.summary,
                infos: saleItem.infos,
                price: variants.length > 0 ? variants[0].price : saleItem.price,
                packagesPrice: saleItem.packages
                    ? saleItem.packages.reduce((acc, pack) => (pack.included ? acc + pack.package.price : acc), 0)
                    : 0,
                optionsPrice: saleItem.options
                    ? saleItem.options.reduce((acc, option) => option.included ? acc + option.price * option.quantity : acc, 0)
                    : 0,
                id: saleItem.id,
                item: saleItem,
                fieldValues: saleItem.fieldValues,
                variants: saleItem.variants,
                configuration: saleItem.configuration
            });
        });
        columns.push({
            column: 'image',
            type: 'image',
            header: '',
            footer: '',
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(SaleItemIcon, { item: value.item })));
            }
        });
        if (!hideSku) {
            columns.push({
                column: 'sku',
                header: t('SKU'),
                footer: t('SKU'),
                render: (value) => {
                    return (React.createElement(Fragment, null,
                        React.createElement(Text, { className: "table-row-title", value: value.sku })));
                }
            });
        }
        columns.push({
            column: 'title',
            header: t('Name'),
            footer: t('Name'),
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { className: "table-row-title", value: value.title })));
            }
        });
        if (promotedFields === null || promotedFields === void 0 ? void 0 : promotedFields.length) {
            promotedFields.forEach((field) => {
                columns.push({
                    column: field.name,
                    header: field.title,
                    infos: field.infos,
                    footer: field.title,
                    render: (value) => {
                        var _a, _b, _c;
                        return (React.createElement(Fragment, null,
                            React.createElement(Text, { className: "table-row-title", value: value.fieldValues &&
                                    ((_a = value.fieldValues) === null || _a === void 0 ? void 0 : _a.find((v) => v.field.id === field.id))
                                    ? getFieldValueLabel((_c = (_b = value.fieldValues) === null || _b === void 0 ? void 0 : _b.find((v) => v.field.id === field.id)) === null || _c === void 0 ? void 0 : _c.value, field, language)
                                    : '' })));
                    }
                });
            });
        }
        else {
            columns.push({
                column: 'infos',
                header: t('Description'),
                footer: t('Description'),
                render: (value) => {
                    return (React.createElement(Fragment, null,
                        React.createElement(Text, { className: "table-row-title", html: true, value: value.summary, ellipsize: true })));
                }
            });
        }
        columns.push({
            column: 'quantity',
            header: t('Quantity'),
            footer: t('Quantity'),
            render: (value) => {
                return (React.createElement(Fragment, null,
                    React.createElement("div", { className: "table-row-value--quantity", onClick: (e) => {
                            e.stopPropagation();
                        } },
                        React.createElement(FormInput, { type: "number", className: "table-row-value table-row-value--quantity", value: "1", min: "1", onChange: (value) => {
                                onQuantityChange(Number(value));
                            }, size: "small" }))));
            }
        });
        columns.push({
            column: 'price',
            header: t('Base Price'),
            footer: t('Base Price'),
            align: 'right',
            render: (value) => {
                return (React.createElement("div", { className: "table-row-value table-row-value--price" },
                    React.createElement(Money, { value: calculatePriceCurrency(value.price, defaultCurrency) })));
            }
        });
        columns.push({
            column: 'packages',
            header: t('Packages'),
            footer: t('Packages'),
            align: 'right',
            render: (value) => {
                return (React.createElement("div", { className: "table-row-value table-row-value--price" },
                    React.createElement(Money, { value: calculatePriceCurrency(value.packagesPrice, defaultCurrency) })));
            }
        });
        columns.push({
            column: 'options',
            header: t('Options'),
            footer: t('Options'),
            align: 'right',
            render: (value) => {
                return (React.createElement("div", { className: "table-row-value table-row-value--price" },
                    React.createElement(Money, { value: calculatePriceCurrency(value.optionsPrice, defaultCurrency) })));
            }
        });
        columns.push({
            column: 'total',
            header: t('Total'),
            footer: t('Total'),
            align: 'right',
            render: (value) => {
                return (React.createElement("div", { className: "table-row-value table-row-value--price" },
                    React.createElement(Money, { value: calculatePriceCurrency(value.price + value.packagesPrice + value.optionsPrice, defaultCurrency) })));
            }
        });
        columns.push({
            type: 'actions',
            header: '',
            footer: '',
            render: (value) => {
                return (React.createElement(Fragment, null, loadingRow !== value.id ? (React.createElement(Button, { style: "circle", picto: value.configuration == 'SIMPLE' ||
                        value.configuration == 'FINISHED'
                        ? 'plus'
                        : 'gear', onPress: () => {
                        setLoadingRow(value.id);
                        addItem(value.item);
                    } })) : (React.createElement(Spinner, { className: "deal-item-picker-browse-table-spinner" }))));
            }
        });
    }
    // Build schema
    const schema = {};
    columns.forEach((column, index) => {
        schema['c' + (index + 1)] = column;
    });
    schema['@'] = {
        render: (value) => {
            var _a;
            setLoadingRow((_a = value.variantId) !== null && _a !== void 0 ? _a : value.id);
            addItem(value);
        }
    };
    if (values == null) {
        values = [];
    }
    const ready = fetching == false;
    let emptyMessagePicto = 'fal user-circle';
    let emptyMessageTitle = `${t('You don’t have any')} ${customLabels['item'][language]} ${t('yet.')}`;
    if (searching || filterBy) {
        emptyMessagePicto = 'fal user-circle';
        emptyMessageTitle = `${t('No')} ${customLabels['item'][language]} ${t(' found based on your search or filter.')}`;
    }
    const className = classNames('deal-item-picker-browse-pane-table', {
        'deal-item-picker-browse-pane-table-variant': itemsDisplay === 'ITEM_WITH_VARIANT'
    }, {
        'deal-item-picker-browse-pane-table-variant-grouped': itemsDisplay === 'VARIANT_GROUPED'
    }, props.className);
    return (React.createElement(Table, { className: className, ready: ready, schema: schema, values: formattedValues, primaryColumn: primaryColumn, actionsColumn: "c6", emptyMessagePicto: emptyMessagePicto, emptyMessageTitle: emptyMessageTitle, isCardDisplay: isCardDisplay, heading: React.createElement(TableActions, { searchable: true, filterable: false, filterListField: "category", filterListValue: ['PRODUCT_CONFIGURATION', 'PRODUCT'], refetchQuery: SaleItemsListQuery, refetchQueryFieldName: 'saleItems', onSearch: onSearch, cardDisplay: cardDisplay, isCardDisplay: isCardDisplay, setIsCardDisplay: setIsCardDisplay }) }));
}
